import * as React from 'react'
import {
  Box,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  Slider,
  Typography
} from '@mui/material'
import {
  MaterialUIPickers,
  CountryAddressSelector,
  OrganizationsTypeSelect, useCountriesLuts
  , ButtonWithIcon
} from 'components'
import { type Country } from 'services'
import CleaningServicesIcon from '@mui/icons-material/CleaningServices'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { type SloFilters } from 'pages'
import dayjs, { type Dayjs } from 'dayjs'

export interface SloTableFiltersProps {
  filters: SloFilters
  updateFilters: (filters: any) => void
  doFilter: () => Promise<void>
  cleanFilters: () => void
}

export const SlosFilters: React.FC<SloTableFiltersProps> = ({ filters, updateFilters, doFilter, cleanFilters }) => {
  const { lutValues: countriesLutValues } = useCountriesLuts()

  const handleFilterClick = (): void => {
    if (filters.page === 1) {
      doFilter().catch((reason) => { console.log(reason) })
    } else {
      updateFilters({ page: 1 })
    }
  }

  const handleDateChange = (filterKey: string, newValue: Dayjs | null): void => {
    updateFilters({ [filterKey]: newValue?.format('YYYY-MM-DD HH:MM:00') })
  }
  const handlerClean = (): void => { cleanFilters() }

  return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2, mt: 3 }}>
        <Card sx={{ flex: 1, p: 1.5, borderRadius: 4 }}>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <FormControl variant="outlined" fullWidth={true}>
                  <InputLabel>Organization Type</InputLabel>
                  <OrganizationsTypeSelect updateFilters={updateFilters} filters={filters} disabled={false} label={'Organization Type'} />
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <FormControl variant="outlined" fullWidth={true}>
                  <CountryAddressSelector countries={countriesLutValues.countries} value={filters.country} setValue={(country: Country | null) => { updateFilters({ country }) }} disabled={false}/>
                </FormControl>
              </Grid>
              <Grid item xs={2}>
                  <MaterialUIPickers value={filters.start_date !== null ? dayjs(filters.start_date) : null} namelabel='Start date' onChange={(newValue) => { handleDateChange('start_date', newValue) }}></MaterialUIPickers>
              </Grid>
              <Grid item xs={2}>
                  <MaterialUIPickers value={filters.end_date !== null ? dayjs(filters.end_date) : null} namelabel='End date' onChange={(newValue) => { handleDateChange('end_date', newValue) }}></MaterialUIPickers>
              </Grid>
              <Grid item xs={1}/>
              <Grid item xs={3}>
                <Box pl={1}>
                  <Typography mt={-1} pb={0.5} variant={'subtitle2'}>Number of Days:</Typography>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item>
                      <Typography>{filters.min_days}</Typography>
                    </Grid>
                    <Grid item xs>
                    <Slider
                    getAriaLabel={() => 'Number of Days:'}
                    max={360}
                    value={[filters.min_days, filters.max_days]}
                    onChange={(e, value) => { if (Array.isArray(value)) updateFilters({ min_days: value[0], max_days: value[1] }) } }
                    valueLabelDisplay="off"
                />
                    </Grid>
                    <Grid item>
                      <Typography>{filters.max_days === 360 ? 'Max' : filters.max_days}</Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              <Grid item xs={6} />
              <Grid item xs={1.5}>
                <ButtonWithIcon fullWidth={true} variant="contained" size='large' nameButton='Search' icon={<FilterAltIcon />} onClick={handleFilterClick}></ButtonWithIcon>
              </Grid>
              <Grid item xs={1.5}>
                <ButtonWithIcon fullWidth={true} variant="contained" size='large' nameButton='Clean' icon={<CleaningServicesIcon />} onClick={handlerClean}></ButtonWithIcon>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
  )
}
